import React from "react";
import SimpleChat from "./components/SimpleChat";  // ✅ SimpleChat import kiya

function App() {
  return (
    <div>
      
      <SimpleChat /> 
    </div>
  );
}

export default App;
